import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import styles from "./styles";
import { Collapse, IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { compose } from "recompose";
import UnassignPickupInfo from "./UnassignPickupInfo";
import { inject, observer } from "mobx-react";

@inject("DispatchStore")
@observer
class UnassignPickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  toggleUnAssignedPickup = () => {
    this.setState((prevState) => ({
      ...prevState,
      expanded: !prevState.expanded,
    }));
  };

  changeSelectedDriver = (option, data) => {
    if (!option) {
      return;
    }
    const driverId = option.value;
    const updatePickupsData = this.props.noFeasibleDriverPickups.map((driver) => {
      if (driver.pickupId.toLowerCase() === data.pickupId.toLowerCase()) {
        return {
          ...driver,
          driverId,
        };
      }
      return driver;
    });
    this.props.updateDriverToUnassignedPickups(updatePickupsData);
    this.props.onUnassignPickupSelection({ ...data, driverId });
  };

  onUnassignPickupCheckboxClick = (e, pickupData) => {
    if (e.target.checked) {
      this.changeSelectedDriver({ value: pickupData.driverId }, pickupData);
    } else {
      this.props.onUnassignPickupDeselection(pickupData.pickupId);
    }
  };

  render() {
    const {
      classes,
      theme,
      selectedUnassignPickupId,
      unassignPickupDropdownError,
      noFeasibleDriverPickups,
    } = this.props;
    const { expanded } = this.state;
    return (
      <>
        <div className={`${classes.headerStyle} ${classes.unAssignHeaderStyle}`}>
          Unassigned Pickups ({noFeasibleDriverPickups.length || 0})
          <IconButton
            aria-expanded={expanded}
            aria-label="show more"
            className={clsx(classes.expandMain, {
              [classes.expandOpen]: expanded,
            })}
            onClick={this.toggleUnAssignedPickup}
          >
            <ExpandMoreIcon />
          </IconButton>
        </div>
        <div className={`${classes.unassignPickupContainer} customScroll`}>
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
            className="customScroll"
          >
            {noFeasibleDriverPickups.length > 0 ? (
              noFeasibleDriverPickups.map((pickup, index) => (
                <UnassignPickupInfo
                  stopDetails={pickup}
                  isSelected={selectedUnassignPickupId.includes(pickup.pickupId)}
                  color={theme.warningColor}
                  classes={classes}
                  key={index}
                  notes={pickup.notes}
                  dispatchedDriversList={
                    this.props.DispatchStore.dispatchedDriversListForOptimization
                  }
                  changeSelectedDriver={this.changeSelectedDriver}
                  onUnassignPickupCheckboxClick={this.onUnassignPickupCheckboxClick}
                  driverDropdownErrorMessage={
                    unassignPickupDropdownError[pickup.pickupId]
                  }
                />
              ))
            ) : (
              <div className={classes.noData}>No Data Available</div>
            )}
          </Collapse>
        </div>
      </>
    );
  }
};

export default compose(withStyles(styles), withTheme())(UnassignPickup);
